var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, computed } from "mobx";
import { SportsConnectionWrapper as SportsConnection } from "../../connections";
import { getSportRequest } from "../../helpers";
import { BranchesParser } from "../../Parser";
export class BranchesRetriever {
    constructor() {
        this.parser = new BranchesParser();
        this.response = new Map();
        this.successCallback = [];
        this.onInitialLoad = (pullResponse) => {
            this.response.clear();
            pullResponse.sports.forEach(sport => {
                this.response.set(sport.id, sport);
            });
            this.isLoaded = true;
            this.successCallback.forEach(f => f(this.responseData));
            this.successCallback = [];
        };
        this.onAdd = (sports) => {
            sports.forEach(sport => {
                this.response.set(sport.id, sport);
            });
        };
        this.onChange = (sportChanges) => {
            sportChanges.forEach(sportChange => {
                const sportToUpdate = this.response.get(sportChange.id);
                sportToUpdate && this.response.set(sportChange.id, Object.assign(Object.assign({}, sportToUpdate), sportChange));
            });
        };
        this.onDelete = (sportIds) => {
            sportIds.forEach(id => {
                this.response.delete(id);
            });
        };
        this.processData = (items) => {
            const legacyItems = [];
            items.forEach((item) => {
                const legacyItem = this.parser.parseData(item);
                legacyItems[legacyItem.ID] = this.parser.parseData(item);
            });
            return legacyItems;
        };
        this.connection = new SportsConnection({ requesterId: "sportsContent" }, {
            Initial: this.onInitialLoad,
            Add: this.onAdd,
            Change: this.onChange,
            Delete: this.onDelete,
            Error: console.error
        });
        this.isLoaded = false;
    }
    get responseData() {
        return this.processData([...this.response.values()]);
    }
    load(successCallback) {
        if (this.connection.query === undefined) {
            this.connection.loadData(getSportRequest());
        }
        !this.isLoaded && this.successCallback.push(successCallback);
        successCallback(this.responseData);
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], BranchesRetriever.prototype, "response", void 0);
__decorate([
    computed.struct,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BranchesRetriever.prototype, "responseData", null);
//# sourceMappingURL=BranchesRetriever.js.map